import React from 'react';

const AboutContent = () => {
  return (
    <div className="bg-[#e7ebf5] dark:bg-[#302f4e] before:border-r-[#e7ebf5] after:border-b-[#e7ebf5] dark:before:border-r-[#302f4e] dark:after:border-b-[#302f4e] px-[15px] py-[30px] rounded-2xl md:after:hidden triangle-top-arrow md:before:block triangle-left-arrow shadow-light">
      <div className="grid grid-cols-1 md:grid-cols-2 ">
        <div className="about-info px-[15px]">
          <p className="dark:text-slate-300 text-[18px]">
            I am Liazul Islam, web developer from Tangail, Dhaka, Bangladesh. I
            have rich experience in web site design and development. I can
            provide clean code and{' '}
            <span className="underline decoration-2 underline-offset-4 decoration-amber-500 ">
              pixel perfect design
            </span>{' '}
            and also make website more & more interactive with web animations. I
            like to Code, Design, Innovate and Experiment.
          </p>
          <div className="mt-4 mb-8 md:mb-0 ">
            <a
              className="py-[10px] px-[18px] bg-black text-white rounded inline-block hover:bg-orange transform translate duration-700 dark:bg-white dark:text-black dark:hover:bg-orange dark:hover:text-white font-medium"
              href="https://drive.google.com/file/d/125N6LPDZLdIvsoy8YvAhje2so-x2deZh/view?usp=sharing"
              target="_blank"
              rel="noopener noreferrer"
            >
              Download Resume
            </a>
          </div>
        </div>
        <div className="skill-info px-[15px]">
          <div className="skill-item">
            <div class="flex justify-between mb-5">
              <span class="text-base font-medium dark:text-white">
                Front-End
              </span>
              <span class="text-sm font-medium dark:text-gray-200">95%</span>
            </div>
            <div class="w-full bg-white dark:bg-gray-200 rounded-full h-[6px] mb-5">
              <div class="bg-[#ffd15c] h-[6px] rounded-full w-[95%] progress-bar progress-95"></div>
            </div>
          </div>
          <div className="skill-item">
            <div class="flex justify-between mb-5">
              <span class="text-base font-medium dark:text-white">
                Back-End
              </span>
              <span class="text-sm font-medium dark:text-gray-200 ">70%</span>
            </div>
            <div class="w-full bg-white dark:bg-gray-200 rounded-full h-[6px] mb-5">
              <div class="bg-[#ff4c60] h-[6px] rounded-full w-[70%] progress-bar progress-70"></div>
            </div>
          </div>
          <div className="skill-item">
            <div class="flex justify-between mb-5">
              <span class="text-base font-medium dark:text-white">
                MERN Stack
              </span>
              <span class="text-sm font-medium dark:text-gray-200">80%</span>
            </div>
            <div class="w-full bg-white dark:bg-gray-200 rounded-full h-[6px]">
              <div class="bg-[#6c6ce5] h-[6px] rounded-full w-[80%] progress-bar progress-80"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutContent;
